module.exports = __webpack_public_path__ + "static/media/1017043.9cfbccbf.png";